import { Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { de } from 'date-fns/locale';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { BaseRedirect } from './components/BaseRedirect';
import { ErrorSnackbar } from './components/error/ErrorSnackbar';
import { ExternApp } from './externApp/ExternApp';
import { selectHasAccessToken } from './features/auth/api/authSlice';
import { InternApp } from './features/internApp/InternApp';
import { LoginScreen } from './features/login/LoginScreen';
import { useAppSelector } from './state/redux.hooks';

function App() {
  const hasAccessToken = useAppSelector(selectHasAccessToken);

  return (
    <Box>
      <Toaster position="top-center" reverseOrder={false} />
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
        <ErrorSnackbar />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<BaseRedirect />} />
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/password-reset" element={<div>pw reset</div>} />
            <Route path="/intern/*" element={<InternApp hasAccessToken={hasAccessToken} />} />
            <Route path="/extern/*" element={<ExternApp hasAccessToken={hasAccessToken} />} />
            <Route path="/projekt/*" element={<BaseRedirect />} />
            <Route path="*" element={<BaseRedirect />} />
          </Routes>
        </BrowserRouter>
      </LocalizationProvider>
    </Box>
  );
}

export default App;
